import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Box, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Iconify from '../../../components/iconify';
import { sendEmailOnForgetPassword, resetPassword } from '../../../api/auth';

// ----------------------------------------------------------------------

export default function ForgetPassword({ setLoginState, setSnackbarMessage, setSnackbarOpen }) {
  const navigate = useNavigate();
  const account = useSelector((state) => state.account.hospitalAccount)
  // console.log({account});
  const [resetPasswordState, setResetPasswordState] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const [email, setEmail] = useState("");
  const [inputs, setInputs] = useState({
    email: "",
    otp: "",
    password: "",
  })
  const handleChange = (e) => {
    if (resetPasswordState) {
      setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    else {
      setEmail(e.target.value)
      setInputs({ ...inputs, email: e.target.value })
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const { data } = resetPasswordState ? await resetPassword({...inputs, hospitalId:account._id}) : await sendEmailOnForgetPassword({ "email": email, hospitalId:account._id });

      // console.log(data);
      if (data.success) {
        setIsLoading(false)
        setSnackbarMessage({ msg: data.message, success: true })
        setSnackbarOpen(true)
        if (resetPasswordState) { setLoginState(true)}
        else {setResetPasswordState(true) }
      }
      else {
        setIsLoading(false)
        setSnackbarMessage({ msg: data.message, success: false })
        setSnackbarOpen(true)

      }
    } catch (error) {
      setIsLoading(false)
      setSnackbarMessage({ msg: error.message, success: false })
      setSnackbarOpen(true)

    }


  };
  return (
    <>
      {resetPasswordState ? (
        <Box component='form' onSubmit={handleSubmit} sx={{ width: '60%' }}>
          <Stack spacing={5} >

            <TextField
              name="otp"
              label="OTP"
              value={inputs.otp}
              onChange={handleChange}
              required
            />

            <TextField
              name="password"
              label="New Password"
              onChange={handleChange}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              required
            />
          </Stack>



          <LoadingButton loading={isLoading} fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }}>
            Change Password
          </LoadingButton>
        </Box>

      ) : (
        <Box component='form' onSubmit={handleSubmit} sx={{ width: '60%' }}>
          <Stack spacing={5} >

            <TextField
              name="email"
              label="Email address"
              value={email}
              onChange={handleChange}
              required
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
            <Link variant="subtitle2" underline="hover" onClick={() => { setLoginState(true) }}>
              Back To Login
            </Link>
          </Stack>

          <LoadingButton loading={isLoading} fullWidth size="large" type="submit" variant="contained" >
            Send OTP
          </LoadingButton>
        </Box>)}
      {/* <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/login', { replace: true })}>
        <Typography>
          Back to log in
        </Typography>
      </Button> */}
    </>
  );
}
